import { useState } from "react";
import ReactDOM from "react-dom";
import { v4 as uuidv4 } from "uuid";
import { bookDeliveryPartners, getDeliveryPartners } from "../../../../config/Services";
import PosCustomTimeSelector from "../../../../customComponents/PosCustomTimeSelector/PosCustomTimeSelector";
import { useSnackbar } from "../../product/hooks/SnackbarProvider";
import "./NewBooking.css";
import PickAndDrop from "./PickAndDrop";

/* ── Inline SVGs ── */
const ChevronLeftIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m15 18-6-6 6-6" />
  </svg>
);
const XIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);
const MapPinIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const BikeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="18.5" cy="17.5" r="3.5" />
    <circle cx="5.5" cy="17.5" r="3.5" />
    <circle cx="15" cy="5" r="1" />
    <path d="M12 17.5V14l-3-3 4-3 2 3h2" />
  </svg>
);
const PackageIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
    <path d="M12 22V12" />
    <polyline points="3.29 7 12 12 20.71 7" />
    <path d="m7.5 4.27 9 5.15" />
  </svg>
);
const TruckIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
    <path d="M15 18H9" />
    <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
    <circle cx="17" cy="18" r="2" />
    <circle cx="7" cy="18" r="2" />
  </svg>
);
const PackageLargeIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
    <path d="M12 22V12" />
    <polyline points="3.29 7 12 12 20.71 7" />
    <path d="m7.5 4.27 9 5.15" />
  </svg>
);
const ZapIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
  </svg>
);
const CalendarDaysIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
    <path d="M3 10h18" />
    <path d="M8 14h.01" />
    <path d="M12 14h.01" />
    <path d="M16 14h.01" />
    <path d="M8 18h.01" />
    <path d="M12 18h.01" />
    <path d="M16 18h.01" />
  </svg>
);
const SearchIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m21 21-4.34-4.34" />
    <circle cx="11" cy="11" r="8" />
  </svg>
);
const AlertCircleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" x2="12" y1="8" y2="12" />
    <line x1="12" x2="12.01" y1="16" y2="16" />
  </svg>
);
const ClockIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);

export default function NewBooking({ handleClose, setRefresh }) {
  const locId = localStorage.getItem("locId");
  const orgId = localStorage.getItem("orgId");
  const showSnackbar = useSnackbar();
  const userDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const [pickupLocation, setPickupLocation] = useState(null);
  const [dropLocation, setDropLocation] = useState(null);
  const [vehicleType, setVehicleType] = useState("TWO_WHEELER");
  const [scheduleType, setScheduleType] = useState("immediate");
  const [pickupDate, setPickupDate] = useState("");
  const [pickupTime, setPickupTime] = useState("");
  const [time, setTime] = useState(null);

  const [vehicleData, setVehicleData] = useState([]);
  const [transactionId, setTransactionId] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [loader, setLoader] = useState(false);
  const [vehicleBookLoader, setVehicleBookLoader] = useState(false);

  const handleVehicleChange = (newVehicle) => {
    if (newVehicle !== null) {
      setVehicleType(newVehicle);
      setVehicleData("");
    }
  };

  const handleScheduleChange = (newSchedule) => {
    if (newSchedule !== null) {
      setScheduleType(newSchedule);
      setVehicleData("");
    }
  };

  const formatToISODateTime = (date, time) => {
    if (!date || !time) return null;
    const dateTimeString = `${date}T${time}:00`;
    const isoString = new Date(dateTimeString).toISOString();
    return isoString;
  };

  const handleFindPartners = async () => {
    setLoader(true);
    try {
      if (scheduleType === "scheduled") {
        if (!pickupDate || !pickupTime) {
          showSnackbar("Please enter the mandatory fields");
          setLoader(false);
          return;
        }
      }

      const payload = {
        transactionId: uuidv4(),
        vehicleType: vehicleType || "",
        pickupDate:
          scheduleType === "immediate" ? null : formatToISODateTime(pickupDate, pickupTime) || "",
        pickupTime: scheduleType === "immediate" ? null : pickupTime || "",
        pickupAddress: {
          name: userDetails?.firstName + userDetails?.secondName || "",
          addressLineOne: pickupLocation?.addressLineOne || "",
          addressLineTwo: pickupLocation?.addressLineTwo || "",
          city: pickupLocation?.city || "",
          state: pickupLocation?.state || "",
          pincode: pickupLocation?.pincode || "",
          contactNumber: userDetails?.mobileNumber,
          latitude: pickupLocation?.latitude || "",
          longitude: pickupLocation?.longitude || "",
        },
        dropAddress: {
          name: dropLocation?.name || "",
          addressLineOne: dropLocation?.structured_formatting?.main_text || "",
          addressLineTwo: dropLocation?.structured_formatting?.secondary_text || "",
          city: dropLocation?.city || "",
          state: dropLocation?.state || "",
          pincode: dropLocation?.pincode || "",
          contactNumber: dropLocation?.contactNumber || "",
          latitude: dropLocation?.latitude || "",
          longitude: dropLocation?.longitude || "",
        },
      };

      const response = await getDeliveryPartners(payload);

      if (response?.data?.data?.errorMessage) {
        showSnackbar(
          response?.data?.data?.errorMessage || "Failed to fetch delivery partners",
          "error"
        );
        return;
      }

      if (response?.data?.status === "SUCCESS") {
        setTransactionId(response?.data?.data?.transactionId);
        const vehicles = response?.data?.data?.vehicleOptions?.[vehicleType] || [];

        setVehicleData(
          vehicles?.map((item) => ({
            ...item,
            id: uuidv4(),
          }))
        );
      }
    } catch (err) {
      showSnackbar("Something went wrong", "error");
    } finally {
      setLoader(false);
    }
  };

  const handleVehicleBook = async () => {
    setVehicleBookLoader(true);
    try {
      if (scheduleType === "scheduled") {
        if (!pickupDate || !pickupTime) {
          showSnackbar("Please enter the mandatory fields");
          setLoader(false);
          return;
        }
      }

      const payload = {
        transactionId: transactionId || "",
        assignmentMode: "ADHOC",
        selectedProvider: selectedVehicle?.provider || "",
        sourceChannel: "adhoc",
        pickupDate: scheduleType === "immediate" ? null : pickupDate || "",
        pickupTime: scheduleType === "immediate" ? null : pickupTime || "",
        cod: true,
        pickupAddress: {
          name: userDetails?.firstName + userDetails?.secondName || "",
          addressLineOne: pickupLocation?.addressLineOne || "",
          addressLineTwo: pickupLocation?.addressLineTwo || "",
          city: pickupLocation?.city || "",
          state: pickupLocation?.state || "",
          pincode: pickupLocation?.pincode || "",
          contactNumber: pickupLocation?.contactNumber,
          latitude: pickupLocation?.latitude || "",
          longitude: pickupLocation?.longitude || "",
        },
        dropAddress: {
          name: dropLocation?.name || "",
          addressLineOne: dropLocation?.structured_formatting?.main_text || "",
          addressLineTwo: dropLocation?.structured_formatting?.secondary_text || "",
          city: dropLocation?.city || "",
          state: dropLocation?.state || "",
          pincode: dropLocation?.pincode || "",
          contactNumber: dropLocation?.contactNumber || "",
          latitude: dropLocation?.latitude || "",
          longitude: dropLocation?.longitude || "",
        },
        scheduledTime: null,
        dropInstructions: null,
        pickupOtp: null,
        deliveryOtp: null,
        prepaid: false,
        orgId: orgId,
        locationId: locId,
      };

      const response = await bookDeliveryPartners(payload);
      if (response?.data?.data?.es) {
        showSnackbar(response?.data?.data?.message || "Something went wrong", "error");
        return;
      }

      showSnackbar("Booking Successful", "success");
      handleClose();
      setRefresh(true);
    } catch (err) {
      showSnackbar("Something went wrong", "success");
    } finally {
      setVehicleBookLoader(false);
    }
  };

  const convertStringTo24Hour = (timeString) => {
    if (!timeString) return null;

    const [time, period] = timeString.split(" ");
    let [hour, minute] = time.split(":");

    let hour24 = parseInt(hour, 10);

    if (period === "PM" && hour24 !== 12) {
      hour24 += 12;
    }

    if (period === "AM" && hour24 === 12) {
      hour24 = 0;
    }

    return `${hour24.toString().padStart(2, "0")}:${minute}`;
  };

  const isFindDisabled =
    loader ||
    !dropLocation?.name ||
    !dropLocation?.contactNumber ||
    (dropLocation?.contactNumber && dropLocation.contactNumber.length < 10) ||
    !dropLocation?.latitude ||
    !dropLocation?.longitude;

  return ReactDOM.createPortal(
    <>
      {/* <div className="nb___backdrop" onClick={handleClose} /> */}
      <div className="nb___drawer" data-testid="drawer-create-delivery-request">
        {/* ── Header ── */}
        <div className="nb___header">
          <div className="nb___header-left">
            <button
              type="button"
              className="nb___back-btn"
              onClick={handleClose}
              data-testid="button-back-create-delivery-request"
            >
              <ChevronLeftIcon />
            </button>
            <div>
              <p className="nb___title">New Booking</p>
              <p className="nb___subtitle">Compare rates and book delivery partners</p>
            </div>
          </div>
          <button
            type="button"
            className="nb___close-btn"
            onClick={handleClose}
            data-testid="button-close-create-delivery-request"
          >
            <XIcon />
          </button>
        </div>

        {/* ── Body ── */}
        <div className="nb___body">
          {/* ── Left panel ── */}
          <div className="nb___left-panel">
            {/* Location card — pickup + drop inputs only */}
            <div className="nb___location-card">
              <div className="nb___loc-inner">
                <div className="nb___loc-indicator">
                  <span className="nb___dot-filled" />
                  <div className="nb___loc-line" />
                  <span className="nb___dot-outline">
                    <MapPinIcon />
                  </span>
                </div>
                <div className="nb___pick-drop-wrap">
                  <PickAndDrop
                    pickupLocation={pickupLocation}
                    setPickupLocation={setPickupLocation}
                    dropLocation={dropLocation}
                    setDropLocation={setDropLocation}
                  />
                </div>
              </div>

              {/* Drop Location Details */}
              <div className="nb___section">
                <p className="nb___section-title">Drop Location Details</p>
                <div className="nb___grid-2">
                  <div>
                    <label className="nb___field-label">Name*</label>
                    <input
                      type="text"
                      className="nb___input"
                      placeholder="Enter the name"
                      data-testid="input-logistics-customer-name"
                      value={dropLocation?.name || ""}
                      onChange={({ target }) =>
                        setDropLocation((prev) => ({ ...prev, name: target.value }))
                      }
                    />
                  </div>
                  <div>
                    <label className="nb___field-label">Phone No.*</label>
                    <div className="nb___phone-row">
                      <button
                        type="button"
                        className="nb___country-code"
                        data-testid="button-logistics-country-code"
                      >
                        +91
                      </button>
                      <input
                        type="tel"
                        className="nb___input"
                        placeholder="Phone number"
                        data-testid="input-logistics-phone-number"
                        maxLength={10}
                        value={dropLocation?.contactNumber || ""}
                        onChange={({ target }) => {
                          const value = target.value.replace(/\D/g, "");
                          if (value?.length <= 10) {
                            setDropLocation((prev) => ({ ...prev, contactNumber: value }));
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Vehicle Type */}
              <div className="nb___section">
                <label className="nb___field-label">Vehicle Type*</label>
                <div className="nb___vehicle-grid">
                  <button
                    type="button"
                    className={`nb___vehicle-btn${
                      vehicleType === "TWO_WHEELER" ? " nb___vehicle-btn--active" : ""
                    }`}
                    onClick={() => handleVehicleChange("TWO_WHEELER")}
                    data-testid="button-logistics-vehicle-2-wheeler"
                  >
                    <BikeIcon />
                    <span>2 Wheeler</span>
                  </button>
                  <button
                    type="button"
                    className={`nb___vehicle-btn${
                      vehicleType === "THREE_WHEELER" ? " nb___vehicle-btn--active" : ""
                    }`}
                    onClick={() => handleVehicleChange("THREE_WHEELER")}
                    data-testid="button-logistics-vehicle-3-wheeler"
                  >
                    <PackageIcon />
                    <span>3 Wheeler</span>
                  </button>
                  <button
                    type="button"
                    className={`nb___vehicle-btn${
                      vehicleType === "MINI_TRUCK" ? " nb___vehicle-btn--active" : ""
                    }`}
                    onClick={() => handleVehicleChange("MINI_TRUCK")}
                    data-testid="button-logistics-vehicle-mini-truck"
                  >
                    <TruckIcon />
                    <span>Mini Truck</span>
                  </button>
                </div>
              </div>

              {/* Schedule */}
              <div className="nb___section">
                <label className="nb___field-label">Schedule*</label>
                <div className="nb___schedule-row">
                  <button
                    type="button"
                    className={`nb___schedule-btn${
                      scheduleType === "immediate" ? " nb___schedule-btn--active" : ""
                    }`}
                    onClick={() => handleScheduleChange("immediate")}
                    data-testid="button-logistics-schedule-immediate"
                  >
                    Immediate Pickup <ZapIcon />
                  </button>
                  <button
                    type="button"
                    className={`nb___schedule-btn${
                      scheduleType === "scheduled" ? " nb___schedule-btn--active" : ""
                    }`}
                    onClick={() => handleScheduleChange("scheduled")}
                    data-testid="button-logistics-schedule-scheduled"
                  >
                    Scheduled Pickup <CalendarDaysIcon />
                  </button>
                </div>
              </div>

              {/* Date / Time — scheduled only */}
              {scheduleType === "scheduled" && (
                <div className="logistic-date-picker-container">
                  <div className="logistic-date-picker-wrapper">
                    <p>Pickup Date*</p>
                    <input
                      type="date"
                      className="logistic-date-input"
                      placeholder="dd/mm/yyyy"
                      value={pickupDate}
                      onChange={(e) => setPickupDate(e.target.value)}
                    />
                  </div>
                  <div className="logistic-date-picker-wrapper">
                    <p>Pickup Time*</p>
                    <PosCustomTimeSelector
                      value={time}
                      onChange={(selectedTime) => {
                        setTime(selectedTime);
                        const time24 = convertStringTo24Hour(selectedTime);
                        setPickupTime(time24);
                      }}
                      dropdownPosition="top"
                      width="100%"
                      padding="6px 10px"
                      radius="20px"
                    />
                  </div>
                </div>
              )}

              {/* Find Partners */}
              <button
                type="button"
                className="nb___find-btn"
                onClick={handleFindPartners}
                disabled={isFindDisabled}
                data-testid="button-logistics-find-partners"
              >
                <SearchIcon />
                Find Delivery Partners
              </button>
            </div>
          </div>

          {/* ── Right panel ── */}
          <div className="nb___right-panel">
            {!vehicleData.length ? (
              <div className="nb___empty-state">
                {loader ? (
                  <span className="nb___spinner" />
                ) : (
                  <>
                    <span className="nb___empty-icon">
                      <PackageLargeIcon />
                    </span>
                    <p className="nb___empty-title">Waiting for Details</p>
                    <p className="nb___empty-sub" data-testid="text-logistics-partner-idle-state">
                      Enter pickup and drop locations to fetch real-time quotes from ONDC partners.
                    </p>
                  </>
                )}
              </div>
            ) : (
              <div className="nb___with-data">
                {loader ? (
                  <div className="nb___loader-center">
                    <span className="nb___spinner" />
                  </div>
                ) : (
                  <>
                    <p className="nb___partners-title">
                      Available Partners ({vehicleData?.length})
                    </p>
                    <div className="nb___vehicle-list">
                      {vehicleData?.map((el) => (
                        <div
                          key={el.id}
                          className={`nb___vehicle-card${
                            el.id === selectedVehicle.id ? " nb___vehicle-card--selected" : ""
                          }`}
                          onClick={() => setSelectedVehicle(el)}
                        >
                          <div className="nb___vehicle-card-left">
                            <div className="nb___provider-badge">
                              {(el?.provider || "N/A").slice(0, 3).toUpperCase()}
                            </div>
                            <div>
                              <p className="nb___provider-name">{el?.provider || "N/A"}</p>
                              <div className="nb___provider-eta">
                                <ClockIcon /> {el?.dropEtaMinutes || "N/A"}
                              </div>
                            </div>
                          </div>
                          <p className="nb___vehicle-cost">₹{el?.deliveryCost || "N/A"}</p>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ── Footer ── */}
        <div className="nb___footer">
          <div className="nb___footer-hint">
            <AlertCircleIcon />
            <span data-testid="text-logistics-booking-hint">
              Choose details and fetch quotes before booking.
            </span>
          </div>
          <button
            type="button"
            className="nb___book-btn"
            onClick={handleVehicleBook}
            disabled={!selectedVehicle || vehicleBookLoader}
            data-testid="button-logistics-book-partner"
          >
            {vehicleBookLoader ? <span className="nb___spinner nb___spinner--sm" /> : "Book"}
          </button>
        </div>
      </div>
    </>,
    document.body
  );
}
